import { OpenAPI } from '../core/OpenAPI'

// set custom api path
export function setEndpoint() {
  OpenAPI.WITH_CREDENTIALS = true
  OpenAPI.ENCODE_PATH = encodeURIComponent
  if (process.env.NEXT_PUBLIC_API_BASE) {
    OpenAPI.BASE = process.env.NEXT_PUBLIC_API_BASE
  }
}
